// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8024":"b72956d5","9355":"80ff9fd4"}[chunkId] + ".chunk.css";
};